import ReactSelect, { OptionTypeBase, Props } from "react-select";

import { styles } from "./styles";
import ClearIndicator from "./ClearIndicator";
import Label from "./styled-components/Label";

import FlexColumn from "common/components/styled-components/FlexColumn";

interface SelectProps extends Props<OptionTypeBase> {
  label?: string;
}

function Select({ label, name, ...props }: SelectProps) {
  return (
    <FlexColumn>
      {label != null && <Label htmlFor={"select_" + name}>{label}</Label>}
      <ReactSelect
        {...props}
        id={"select_" + name}
        styles={styles}
        components={{ ClearIndicator: ClearIndicator }}
      />
    </FlexColumn>
  );
}

export default Select;
